export default __webpack_public_path__ + "static/bucharest_hotel_1-b2a654a2c98907a266939865932d6ef7.webp";